import { Button } from "antd";
import "./BrandsHome.scss";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Api from "../../network/ApiConfig";

function BrandsHome() {
  const [brandList, setbrandList] = useState([]);

  useEffect(() => {
    handelGetBarnds();
  }, []);

  const handelGetBarnds = () => {
    Api.get("CarBrands/GetTop10Brands").then(
      (res) => {
        if (res?.status === 200) {
          console.log("sdfasdsdafdsf", res?.data);
          setbrandList(res?.data?.model || []);
        }
        // setbrandList();
      },
      (err) => {
        // console.log(err, "errrrrrrrrrrrrrrrrrrrrrrrrrrr")
      }
    );
  };

  return (
    <div
      className="home-section-wrapper brand-section-wrapper"
      id="brand-section"
    >
      <h1 className="page-title"> السيارات حسب الماركة</h1>
      <Link to="/cars">
        <Button type="primary" size="large">
          المزيد
        </Button>
      </Link>
      <div className="category-list-holder">
        {brandList?.map((ele) => (
          <Link
            to={{
              pathname: "/cars",
              search: `?CarBrandId=${+ele?.Id}&CarBrandName=${ele?.NameLT}`,
            }}
            className="category-card-holder"
          >
            <img src={ele?.Image || ""} alt="" />
            <p>{ele?.NameLT}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default BrandsHome;
